import { BrandItem, ColorCategoryItem, Config } from "../interfaces/Config";

export const getColorByCategories = (config: Config) => {
  const { colors, categories } = config;
  const colorByCategories: ColorCategoryItem[] = [];
  categories.map((category) => {
    const allColors = colors?.filter((color) =>
      color.categoryId.includes(category.id)
    );

    const allColorsSortedBrands = allColors.filter((a) => a.product.isSalon);
    const allColorsSortedPdp = allColors.filter((a) => !a.product.isSalon);
    const finalColors = allColorsSortedBrands.concat(allColorsSortedPdp);

    colorByCategories.push({ ...category, colors: finalColors });
  });
  return colorByCategories.length > 0 ? colorByCategories : undefined;
};

export const getColorByBrands = (config: Config) => {
  const { colors, brands } = config;
  const salonBrand: BrandItem[] = [];
  const detailBrand: BrandItem[] = [];
  let colorByBrands: BrandItem[] = [];
  brands.map((brand) => {
    const allColors = colors?.filter(
      (color) => color?.product?.brandId === brand.id
    );
    let isSalon = false;
    const allColorsSortedBrands = allColors.filter((a) => a.product.isSalon);
    const allColorsSortedPdp = allColors.filter((a) => !a.product.isSalon);
    const finalColors = allColorsSortedBrands.concat(allColorsSortedPdp);
    if (allColorsSortedBrands.length > 0) {
      isSalon = true;
      salonBrand.push({ ...brand, colors: finalColors, isSalon: isSalon });
    } else {
      detailBrand.push({ ...brand, colors: finalColors, isSalon: isSalon });
    }
  });
  colorByBrands = salonBrand.concat(detailBrand);

  return colorByBrands.length > 0 ? colorByBrands : undefined;
};
